"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initCap = exports.inflect = exports.replacePlaceholders = void 0;
const tslib_1 = require("tslib");
const handlebars_1 = tslib_1.__importDefault(require("handlebars"));
const moment_1 = tslib_1.__importDefault(require("moment"));
const date_1 = require("../constants/date");
handlebars_1.default.Utils.escapeExpression = (text) => text ? JSON.stringify(text) : "";
handlebars_1.default.registerHelper("duration", 
// + is used to remove any trailing zeros
(number, fromUnit, toUnit) => +moment_1.default.duration(number !== null && number !== void 0 ? number : 0, fromUnit).as(toUnit).toFixed(1));
handlebars_1.default.registerHelper("add", (...args) => 
// The last arg is an object pushed by Handlebars
args.slice(0, -1).reduce((prev, curr) => prev + (curr !== null && curr !== void 0 ? curr : 0), 0));
handlebars_1.default.registerHelper("date", (dateString, formatType) => {
    // Last arg might be an object pushed by Handlebars if no formatType was explicitly set in the template
    formatType = (typeof formatType !== "string") ? "date" : formatType;
    let dateFormat;
    switch (formatType) {
        case "date":
            dateFormat = date_1.DATE_FORMATS_24_HOURS[date_1.DateFormat.Long];
            break;
        case "datetime":
            dateFormat = date_1.DATE_FORMATS_24_HOURS[date_1.DateFormat.LongWithTime];
            break;
        case "datetimetz":
            dateFormat = date_1.DATE_FORMATS_24_HOURS[date_1.DateFormat.LongWithDayTimeAndZone];
            break;
        default:
            throw new Error(`Unknown format type: ${formatType}`);
    }
    return moment_1.default(dateString).format(dateFormat);
});
handlebars_1.default.registerHelper("dateDiff", (baseDate, diffDate, diffUnit, returnUnit = false, singularUnit = undefined) => {
    if (!baseDate) {
        throw new Error(`Unable to calculate date diff with invalid baseDate: ${baseDate}`);
    }
    if (!diffDate) {
        throw new Error(`Unable to calculate date diff with invalid diffDate: ${diffDate}`);
    }
    if (!diffUnit) {
        throw new Error(`Unable to calculate date diff with invalid diffUnit: ${diffUnit}`);
    }
    const diff = moment_1.default(baseDate).diff(diffDate, diffUnit);
    if (returnUnit) {
        if (!singularUnit) {
            throw new Error("Unable to generate dateDiff with 'returnUnit' enabled without providing a singular unit name");
        }
        return exports.inflect(diff, singularUnit, diffUnit, true);
    }
    return diff;
});
handlebars_1.default.registerHelper("list", (context = [], block) => {
    let ret = "";
    for (let i = 0, j = context.length; i < j; i++) {
        ret = ret + block.fn(context[i]);
        if (i < j - 1) {
            ret = ret + ", ";
        }
    }
    return ret;
});
handlebars_1.default.registerHelper("inflect", (count, singularForm, pluralForm, returnCount = true) => exports.inflect(count, singularForm, pluralForm, returnCount));
handlebars_1.default.registerHelper("div", (numeratorString, denominatorString, percent = false, decimalPlaces = 2) => {
    const numerator = parseInt(numeratorString, 10);
    const denominator = parseInt(denominatorString, 10);
    let value;
    if (denominator === 0 || isNaN(denominator)) {
        value = 0;
    }
    else if (numerator === 0 || isNaN(numerator)) {
        value = 0;
    }
    else {
        value = (numerator / denominator);
    }
    if (percent === true) {
        return `${(value * 100).toFixed(decimalPlaces)}%`;
    }
    return value.toFixed(decimalPlaces);
});
handlebars_1.default.registerHelper("switch", function _switch(value, options) {
    this.switch_value = value;
    return options.fn(this);
});
handlebars_1.default.registerHelper("case", function _case(value, options) {
    if (value === this.switch_value) {
        return options.fn(this);
    }
});
exports.replacePlaceholders = (text, parameters, helpers = {}) => handlebars_1.default.create().compile(text)(parameters, {
    helpers: Object.assign({}, handlebars_1.default.helpers, helpers)
});
exports.inflect = (count, singular, plural, returnCount = true) => {
    const inflection = count === 1 ? singular : plural;
    return returnCount
        ? `${count} ${inflection}`
        : inflection;
};
// NOTE: This is a copy of Postgres's InitCap function
exports.initCap = (str) => {
    return (str.toLowerCase()).replace(/(^|[^a-zA-Z\u00C0-\u017F])([a-zA-Z\u00C0-\u017F])/g, (c) => {
        return c.toUpperCase();
    });
};
//# sourceMappingURL=string.js.map